import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter } from "react-router-dom"
import { Provider } from "react-redux"

import App from "./App.tsx"
import { store } from "./store/index.ts"
import { getRouterBasename } from "./lib/tenant"
import { TenantProvider } from "./contexts/TenantContext"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <TenantProvider>
      <Provider store={store}>
        <BrowserRouter basename={getRouterBasename()}>
          <App />
        </BrowserRouter>
      </Provider>
    </TenantProvider>
  </StrictMode>
)
